/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'redux-form';

import BasicSelect from '../../../../../shared/components/formComponents/groups/BasicSelect';
import BasicText from '../../../../../shared/components/formComponents/groups/BasicText';
import { VerbRichTextEditor } from '../../../../../shared/components/formComponents/VerbRichTextEditor';
import RichTextNotesHeader from './RichTextNotesHeader';
import CopyAssetLink from '../../../../components/CopyAssetLink';

import BasicToggle from '../../../../../shared/components/formComponents/groups/BasicToggle';
import ImageUpload from '../../../../../shared/components/formComponents/inputs/ImageUpload';
import BasicNumericInput from '../../../../../shared/components/formComponents/groups/BasicNumericInput';

const displayTypeOptions = [
    {
        label: 'Radio',
        value: 'radio'
    },
    {
        label: 'Image',
        value: 'image'
    },
    {
        label: 'Stars',
        value: 'stars'
    },
    {
        label: 'Emotion',
        value: 'emotion'
    },
    {
        label: 'Slider',
        value: 'slider'
    }
];

export class LikertOptions extends Component {
    static propTypes = {
        fields: PropTypes.object.isRequired,
        contentValues: PropTypes.object.isRequired,
        disabled: PropTypes.bool,
        showLabels: PropTypes.bool
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        const {
            contentValues: { start = 0, length = 0 }
        } = this.props;
        const nextStart = nextProps.contentValues.start || 0;
        const nextLength = nextProps.contentValues.length || 0;
        const nextEnd = nextStart + nextLength;
        if (start !== nextStart || length !== nextLength) {
            // 1. Grabs the previous values
            // 2. Clears the current fields
            // 3. Instantiates the new fields using
            // the previousValues.
            //
            // This is done to avoid complicated logic
            // in persisting the correct
            // array index with the score
            const currentVals = {};
            nextProps.fields.forEach((name, idx) => {
                const val = nextProps.fields.get(idx);
                currentVals[val.score] = val;
            });
            nextProps.fields.removeAll();
            for (let scoreIdx = nextStart; scoreIdx < nextEnd; scoreIdx += 1) {
                if (currentVals[scoreIdx]) {
                    nextProps.fields.push({
                        ...currentVals[scoreIdx]
                    });
                } else {
                    nextProps.fields.push({
                        label: '',
                        image: '',
                        score: scoreIdx
                    });
                }
            }
        }
    }

    render() {
        const {
            fields,
            disabled,
            contentValues: { displayType },
            showLabels
        } = this.props;
        return (
            <div className={'col-12'}>
                {fields.map((name, idx) => (
                    <div key={idx} className={'likertSectionItem-optionInput row'}>
                        <label className={'col-4 likertSectionItem-optionScore'}>{`Score: ${
                            fields.get(idx).score
                        }`}</label>
                        {showLabels && (
                            <Field
                                name={`${name}.label`}
                                label={'Label (optional)'}
                                className={'col-8'}
                                component={BasicText}
                                disabled={disabled}
                            />
                        )}
                        {displayType === 'image' ? (
                            <Field
                                name={`${name}.image`}
                                label={'Image'}
                                className={'col-12'}
                                cropProp={{ width: 150, height: 150 }}
                                component={ImageUpload}
                                disabled={disabled}
                            />
                        ) : null}
                    </div>
                ))}
            </div>
        );
    }
}

class LikertSectionItem extends Component {
    static propTypes = {
        contentValues: PropTypes.object.isRequired,
        memberReference: PropTypes.string,
        changeFormValue: PropTypes.func.isRequired,
        sectionItemId: PropTypes.string,
        assetLinkOptions: PropTypes.array,
        isGlobalSectionItem: PropTypes.bool
    };

    componentDidMount() {
        const { contentValues, changeFormValue, memberReference } = this.props;
        if (contentValues.displayType === 'emotion') {
            this.lockLength(5);
        }
        if (!contentValues.start) {
            changeFormValue({
                field: memberReference ? `${memberReference}.content.start` : 'content.start',
                value: 1
            });
        }
        if (!contentValues.length) {
            changeFormValue({
                field: memberReference ? `${memberReference}.content.length` : 'content.length',
                value: 5
            });
        }
        if (!contentValues.displayType) {
            changeFormValue({
                field: memberReference ? `${memberReference}.content.displayType` : 'content.displayType',
                value: 'radio'
            });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.contentValues.displayType === 'emotion' && this.props.contentValues.displayType !== 'emotion') {
            this.lockLength(5);
        }
    }

    lockLength = (newLength) => {
        const { changeFormValue, memberReference } = this.props;
        changeFormValue({
            field: memberReference ? `${memberReference}.content.length` : 'content.length',
            value: newLength
        });
    };

    getLengthDisabled = () => {
        if (this.props.contentValues.displayType === 'emotion') {
            return true;
        }
        return false;
    };

    render() {
        const { memberReference, contentValues, sectionItemId, isGlobalSectionItem } = this.props;
        return (
            <div key={`${memberReference}-${sectionItemId}`} className={'likertSectionItem col-12'}>
                <div className={'row'}>
                    <div className={'col-7'}>
                        <Field
                            name={memberReference ? `${memberReference}.content.description` : 'content.description'}
                            label={'Description'}
                            className={'col-12'}
                            placeholder={'Enter a description'}
                            component={VerbRichTextEditor}
                            rows={3}
                            readOnly={isGlobalSectionItem}
                        />
                    </div>
                    <div className={'col-5'}>
                        <RichTextNotesHeader />
                        <CopyAssetLink assetLinkOptions={this.props.assetLinkOptions} />
                    </div>
                </div>
                <div className={'row'}>
                    <Field
                        name={memberReference ? `${memberReference}.content.start` : 'content.start'}
                        label={'Start'}
                        className={'col-6'}
                        component={BasicNumericInput}
                        disabled={isGlobalSectionItem}
                    />
                    <Field
                        name={memberReference ? `${memberReference}.content.length` : 'content.length'}
                        maxValue={30}
                        minValue={5}
                        label={'Length'}
                        className={'col-6'}
                        disabled={this.getLengthDisabled() || isGlobalSectionItem}
                        component={BasicNumericInput}
                    />
                </div>
                <div className={'row'}>
                    <Field
                        name={memberReference ? `${memberReference}.content.displayType` : 'content.displayType'}
                        label={'Display Type'}
                        options={displayTypeOptions}
                        component={BasicSelect}
                        className={'col-6'}
                        disabled={isGlobalSectionItem}
                    />
                </div>
                <div className={'row'}>
                    <h5 className={'col-12'}>Options</h5>
                    <Field
                        name={
                            memberReference
                                ? `${memberReference}.content.includeScoreLabels`
                                : 'content.includeScoreLabels'
                        }
                        label={'Display Numeric Values'}
                        component={BasicToggle}
                        className={'col-12'}
                        disabled={isGlobalSectionItem}
                        id={'include-scorable-labels-toggle'}
                    />
                    <FieldArray
                        name={memberReference ? `${memberReference}.content.options` : 'content.options'}
                        contentValues={contentValues}
                        component={LikertOptions}
                        disabled={isGlobalSectionItem}
                        showLabels={contentValues.displayType !== 'stars'}
                    />
                </div>
            </div>
        );
    }
}
export default LikertSectionItem;
